import axios from "axios";
import { getAccessToken } from "../helper/auth";
import { AuthService } from "../services/auth.service";
import { environment } from "../environment";

export const API_URL = environment.serverPath;

const $api = axios.create({
  baseURL: API_URL,
});

$api.interceptors.request.use((config) => {
  config.headers.Authorization = `Bearer ${getAccessToken()}`;
  if (environment.environment === "development") {
    config.headers["ngrok-skip-browser-warning"] = "69420";
  }
  return config;
});

$api.interceptors.response.use(
  (config) => {
    return config;
  },
  async (error) => {
    const originalRequest = error.config;
    if (error.response.status === 401 && error.config && !error.config._isRetry) {
      originalRequest._isRetry = true;
      try {
        const response = await AuthService.refreshToken();
        if (response) {
          localStorage.setItem("access_token", response.data.accessToken);
          localStorage.setItem("refresh_token", response.data.refreshToken);
        }
        return $api.request(originalRequest);
      } catch (e) {
        console.log("Totally unauthorized");
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
      }
    }
    throw error;
  }
);

export default $api;
